<div
  fxLayout
  class="avatar"
  [class.avatar--small]="isSmall()"
  [class.avatar--big]="bigImage()"
  [class.avatar--circle]="shape() === 'circle'"
  [class.avatar--rounded]="shape() === 'rounded'">
  @if (imageUrl() && !imageLoadError()) {
    <img
      class="avatar__image"
      [src]="imageUrl()"
      (error)="onImageError()"
      alt="Avatar" />
  } @else {
    @if (avatarLetters()) {
      <span
        class="avatar__letter"
        [style.background-color]="backgroundColor() || null">
        {{ avatarLetters() }}
      </span>
    }
    @if (!isStatusActive()) {
      <span class="avatar__status pending"></span>
    }
  }
</div>
